import Layout from '../views/Layout'

const route = {
  path: '/',
  component: Layout,
  redirect: 'index',
  children: [{
    path: '/index',
    name: 'index',
    component: resolve => require(['@/views/homepage/index'], resolve)
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: (resolve) => require(['@/views/features/redirect'], resolve)
      }
    ]
  }
  ]
}
export default route



// WEBPACK FOOTER //
// ./src/router/homeRoute.js